// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1ORPg","inputWrap":"styles_inputWrap__uhfBs","input":"styles_input__2O8cP"};